import _ from 'lodash'
import type { NodeRefs, CompNode } from '@wix/thunderbolt-catharsis'
import { createCompRef, compQueriesRefs } from '@wix/thunderbolt-catharsis'
import type {
	CssFeature } from '@wix/thunderbolt-catharsis-extensions'
import {
	componentVisibilityTransformationsFactory,
	containerVisibilityTransformationsFactory,
	componentPatternsFactory,
} from '@wix/thunderbolt-catharsis-extensions'
import type { Component } from '@wix/thunderbolt-becky-types'
import { CompNodeAdapter } from '@wix/thunderbolt-state-manager'

const compSpecificDataFeature = {
	featureName: 'compSpecificData',
	renderableNodes: {
		patterns: componentPatternsFactory(),
		componentVisibilityTransformations: componentVisibilityTransformationsFactory(),
		visibilityTransformations: containerVisibilityTransformationsFactory(),
	},
	intermediateNodes: {},
	dataMaps: [],
} as any

export function getNodesFromFeatures(features: Record<string, CssFeature<any>>) {
	const cssFeatures = Object.values(features)
	cssFeatures.push(compSpecificDataFeature)
	const renderableNodeToFeatures: Record<string, Array<string>> = {}
	const catharsisNodes = cssFeatures.reduce((acc, feature) => {
		const currentRenderableNodes = Object.keys(feature.renderableNodes)
		Object.assign(acc, feature.intermediateNodes, feature.renderableNodes)
		currentRenderableNodes.forEach((renderableNode) =>
			(renderableNodeToFeatures[renderableNode] ??= []).push(feature.featureName)
		)
		return acc
	}, {} as Record<string, CompNode<any, any, any>>)
	const refs = createRefs(catharsisNodes)
	return {
		nodes: Object.entries(catharsisNodes).map(([nodeName, catharsisNode]) =>
			CompNodeAdapter(nodeName, catharsisNode, refs)
		),
		renderableNodeToFeatures,
	}
}

function createRefs(nodes: Record<string, CompNode<any, any, any>>) {
	return {
		..._.mapValues(nodes, (__, key) => (component: Component | string) =>
			createCompRef(key, typeof component === 'string' ? component : component.id)
		),
		...compQueriesRefs,
		modes: (modeId: string) => createCompRef('modes', modeId),
	} as NodeRefs<any>
}
